.appShell {
	height: 100dvh;
	min-height: 0;
	padding: 14px;
	overflow: hidden;
}

.gameConsole {
	display: flex;
	width: 100%;
	max-width: 1800px;
	height: 100%;
	min-height: 0;
	margin: 0 auto;
	overflow: hidden;
	flex-direction: column;
	border: 2px solid #252134;
	border-radius: 18px;
	background: #fff;
}

.workspace {
	position: relative;
	display: block;
	width: 100%;
	max-width: 1800px;
	min-height: 0;
	flex: 1;
	height: auto;
	margin: 0;
}

.battlefield {
	--battlefield-frame-border: 0;
	--battlefield-frame-radius: 0;
	width: 100%;
	height: 100%;
}

@media (max-width: 620px) {
	.appShell {
		padding: 0 6px 7px;
	}
	.gameConsole {
		border-radius: 11px;
	}
	.workspace {
		height: auto;
	}
}

.gameFeedback[data-achievement-visible='true'] > div {
	bottom: max(160px, calc(env(safe-area-inset-bottom) + 148px));
}
